// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mg-mczx/static/js/" + chunkId + "." + {"257":"b860c0e1","407":"bf5537ca","564":"b214bfce","786":"248941b7"}[chunkId] + ".js";
};